export const MAX_LENGTH = 2000;

export const TIMESHEET_NOTES_VARIANT = {
  EMPLOYEE: "employee",
  EMPLOYER: "employer",
};

export const VARIANT_CONFIG = {
  [TIMESHEET_NOTES_VARIANT.EMPLOYEE]: {
    id: "notes-employee",
    label: "Worker note",
    helperTextEditing:
      "Include additional details about any shifts for this timesheet to share with the supervisor.",
    helperTextViewing:
      "Additional details about any shifts for this timesheet from the worker.",
  },
  [TIMESHEET_NOTES_VARIANT.EMPLOYER]: {
    id: "notes-employer",
    label: "Supervisor note",
    helperTextEditing:
      "Include additional details about any shifts for this timesheet to share with the worker.",
    helperTextViewing:
      "Additional details about any shifts for this timesheet from the supervisor.",
  },
};
